import { findFirstNonEmptyString } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { contentHeadlineContent$key } from "~/queries/__generated__/contentHeadlineContent.graphql";

import { ContentHeadlineTag } from "./content-headline-tag";
import { Container, Headline, SponsorHeadline } from "./styles";

export type Props = {
  className?: string;
  hideTag?: boolean;
  hideTooltip?: boolean;
  preferSocialHeadline?: boolean;
  reference: contentHeadlineContent$key;
  useContentSponsorStyle?: boolean;
  useSectionTags?: boolean;
};

export const ContentHeadline: FunctionComponent<Props> = ({
  className,
  hideTag,
  hideTooltip,
  preferSocialHeadline,
  reference: reference_,
  useContentSponsorStyle,
  useSectionTags,
}) => {
  const content = useFragment(
    graphql`
      fragment contentHeadlineContent on Content {
        headline
        socialHeadline
        ...contentHeadlineTagContent
      }
    `,
    reference_,
  );

  const { headline, socialHeadline } = content;
  const sanitizedHeadline = preferSocialHeadline
    ? findFirstNonEmptyString(socialHeadline, headline)
    : findFirstNonEmptyString(headline, socialHeadline);

  if (!sanitizedHeadline) return null;

  return (
    <Container className={className}>
      {!hideTag && (
        <ContentHeadlineTag
          hideTooltip={hideTooltip}
          reference={content}
          useSectionTags={useSectionTags}
        />
      )}
      {useContentSponsorStyle ? (
        <SponsorHeadline>{sanitizedHeadline}</SponsorHeadline>
      ) : (
        <Headline>{sanitizedHeadline}</Headline>
      )}
    </Container>
  );
};

ContentHeadline.displayName = "ContentHeadline";
